module.exports = __webpack_public_path__ + "static/media/Тасевич А.Л..03f41bf6.pdf";